<ion-content *ngIf="!(auth.isAuthenticated$ | push)" data-e2e="login-page">
  <ion-grid>
    <ion-card mode="ios">
      <ion-card-header>
        <ion-card-subtitle>
          <gc-custom-banner
            *ngIf="login.showAlert$ | push"
            (closed)="login.hideAlert()"
            [text]="auth.error$ | push"
            color="gc-alert"
            type="alert"
          >
          </gc-custom-banner>
        </ion-card-subtitle>
        <ion-card-title>
          <img id="go-carrera-logo" src="/assets/images/logo.svg" alt="TradeTap" />
        </ion-card-title>
      </ion-card-header>

      <ion-card-content class="ion-no-padding">
        <ion-button
          data-e2e="login-submit"
          size="large"
          mode="ios"
          expand="block"
          color="gc-alt-green"
          (click)="auth.logIn();"
        >
          Sign In
        </ion-button>
        <ion-button
          data-e2e="start-installer-profile-button"
          size="medium"
          fill="outline"
          mode="ios"
          expand="block"
          color="dark"
          class="ion-align-self-center"
          (click)="login.signUp()"
        >
          Start FREE Profile
        </ion-button>
      </ion-card-content>
    </ion-card>
  </ion-grid>
</ion-content>
